import { useEffect, useState } from 'react';

export const useScrollbarObserver = (element: HTMLDivElement | null) => {
  const [hasScrollbar, setHasScrollbar] = useState(false);

  useEffect(() => {
    if (!element) return;

    const resizeObserver = new ResizeObserver(() => {
      if (element) {
        setHasScrollbar(element.scrollHeight > element.clientHeight);
      }
    });

    resizeObserver.observe(element);

    return () => resizeObserver.disconnect();
  }, [element]);

  return hasScrollbar;
};
